import { ArrowCircleDownIcon, ArrowCircleUpIcon } from "@heroicons/react/outline";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import FmagicMenu from "../FmagicMenu/FmagicMenu";
import FsideBar from "../FsideBar/FsideBar";
import FtopBar from "../FtopBar/FtopBar";
import { useFMasterPage } from "./hooks/useFMasterPage";
import styles from "./style/FMasterPage.css";

const FMasterPage = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const route = useNavigate();



  return (
    <>
      <FsideBar setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
      <FtopBar setSidebarOpen={setSidebarOpen}>
        <div className="p-5">{children}</div>
      </FtopBar>
      <FmagicMenu setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
    </>
  );
};

export default FMasterPage;
